import { CustomColumnTypes } from "@/enum/list.enum";

import { ColumnConfig } from "../../../../List/schema/columnConfig";

/** Builds the editor placeholder token for an AI snippet column. */
export const buildSnippetToken = (columnId: number | string, name: string): string =>
	`{column_${columnId}_${name}|${name}}`;

/** Finds an AI_SNIPPET column by name (case- and whitespace-insensitive). */
export const findSnippetColumnByName = (
	columns: ColumnConfig[] | undefined,
	name: string
): ColumnConfig | undefined => {
	const target = name.toLowerCase().trim();

	return (columns ?? []).find(
		(c) => c.type === CustomColumnTypes.AI_SNIPPET && c.name?.toLowerCase().trim() === target
	);
};

/**
 * Returns a rewriter that replaces every `{column_<id>_<oldName>|<oldName>}`
 * token of the given column with the new name.
 */
export const buildColumnTokenRewriter =
	(columnId: number, newName: string) =>
	(text: string): string => {
		if (!text) {
			return text;
		}

		const pattern = new RegExp(`\\{column_${columnId}_[^}|]+(?:\\|[^}]+)?\\}`, "g");

		return text.replace(pattern, `{column_${columnId}_${newName}|${newName}}`);
	};

/** Extracts the distinct column ids referenced by `{column_<id>_…}` tokens. */
export const extractInsertedColumnIds = (messages: string[]): number[] => {
	const ids = new Set<number>();
	const regex = /\{column_(\d+)_[^}|]+(?:\|[^}]+)?\}/g;

	for (const msg of messages) {
		if (!msg) {
			continue;
		}

		let match: RegExpExecArray | null;

		while ((match = regex.exec(msg)) !== null) {
			ids.add(Number(match[1]));
		}
	}

	return Array.from(ids);
};
